import { useMemo } from 'react';
import { Workflow, WorkflowTypeKey } from '../interfaces/workflow.interface';
import moment from 'moment';
import { Badge } from '../interfaces/users.interface';

// Three months before expiration user can add new workflow ie start new questionnaire
export function useCanAddNewWorkflow(workflows: Workflow[] | undefined) {
  return useMemo(() => {
    return (type: WorkflowTypeKey): boolean => {
      if (!type || !workflows) return false;

      const wfs = workflows?.filter((wf) => wf.workflowType === type);
      if (!wfs || wfs.length === 0) return true;
  
      let badges: Badge[] = [];
      wfs.forEach((wf) => {
        badges = badges.concat(wf.badges as Badge[]);
      });
  
      badges = badges
        .filter((b) => b.title === 'tpn_self_reported')
        .sort((a, b) => moment(b.expirationDate).unix() - moment(a.expirationDate).unix());
  
      if (badges.length === 0) return false;
      if (moment(badges[0].expirationDate).add(-3, 'months').unix() < moment().unix())
        return true;
      return false;
    };
  }, [workflows]);
}
